module.exports = __webpack_public_path__ + "img/zizhukaipai.ffa45e84.png";